import { render } from "./CardItemProxy.vue?vue&type=template&id=87a80996&ts=true"
import script from "./CardItemProxy.vue?vue&type=script&lang=ts"
export * from "./CardItemProxy.vue?vue&type=script&lang=ts"

import "./CardItemProxy.vue?vue&type=style&index=0&id=87a80996&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__